import numeral from 'numeral';
import { Cell } from '@table-library/react-table-library/table';
import { Fragment } from 'react';
import { showDifficulty, showIntent, showSerpFeatures } from '../../../helpers/commerce';

export const COLUMNS = (t) => [
    {
        label: t('commerce.url_detail.columns.keyword'),
        key: 'keyword',
        data: 'keyword',
        sortType: 'string',
        Component: Cell,
        cellSize: 'minmax(200px, 2fr)',
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong className="wripe">{data}</strong>,
    },
    {
        label: t('commerce.url_detail.columns.search_volume'),
        key: 'search_volume',
        data: 'search_volume',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.url_detail.columns.cpc'),
        key: 'cpc',
        data: 'cpc',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => (csvDownload ? data : <strong>${data}</strong>),
    },
    {
        label: t('commerce.url_detail.columns.cpc_competition'),
        key: 'competition',
        data: 'competition',
        info: t('commerce.url_detail.columns.cpc_competition_info'),
        Component: Cell,
        renderCell: ({ data, csvDownload }) => (csvDownload ? data : <strong>{data}</strong>),
    },
    {
        label: t('commerce.url_detail.columns.serp_features'),
        key: 'keywords_serp_features',
        data: 'keywords_serp_features',
        Component: Cell,
        cellSize: 'minmax(180px, 2fr)',
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-center">{showSerpFeatures(data)}</div>
            ),
    },
    {
        label: t('commerce.url_detail.columns.keyword_difficulty'),
        key: 'keyword_difficulty_index',
        data: 'keyword_difficulty_index',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const dot = showDifficulty(data);
            return (
                <div className="d-flex align-items-center">
                    <strong>{data}</strong>
                    {dot}
                </div>
            );
        },
    },
    {
        label: t('commerce.url_detail.columns.intent'),
        key: 'intent',
        data: 'intent',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-center">
                    {showIntent(data)?.map((item, i) => (
                        <Fragment key={i}>{item}</Fragment>
                    ))}
                </div>
            ),
    },
    {
        label: t('commerce.url_detail.columns.number_of_results'),
        key: 'number_of_results',
        data: 'number_of_results',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
];
